import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wct-loading',
  templateUrl: './wct-loading.component.html',
  styleUrls: ['./wct-loading.component.css']
})
export class WctLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
